<template>
  <BlSnackbarMv :active.sync="active" :message="message" :is-error="isError" />
</template>

<script>
import { BlSnackbarMv } from '@bukalapak/bazaar-mweb';
import eventBus from './eventBus';

export default {
  name: 'Snackbar',
  components: {
    BlSnackbarMv,
  },
  data() {
    return {
      active: false,
      isError: false,
      message: '',
    };
  },
  beforeMount() {
    eventBus.$on('show', ({ message, isError }) => {
      this.active = false;
      this.$nextTick(() => {
        this.message = message;
        this.isError = isError;
        this.active = true;
      });
    });
  },
};
</script>
